module.exports = __webpack_public_path__ + "static/media/facebook.c953af4e.svg";